<template>
  <div
    class="ba-w-full ba-p-10 2xs:ba-px-12 xs:ba-px-16"
    :class="{
      'xs:ba-pb-16': !forced
    }"
  >
    <vis-page-manage-header
      :title="$t('managePassword.title')"
      :description="formFieldMessage || formMessage"
      :description-type="descriptionType"
      :messages="formFieldMessages"
      :show-back-button="!forced"
      @click="$emit('back')"
    />
    <form @submit.prevent="onSubmit" @reset.prevent="onReset" class="ba-w-full">
      <fieldset class="ba-mb-5" v-if="wasPassword">
        <vis-form-input
          v-model="form.oldPassword"
          :label="$t('managePassword.currentPasswdLabel')"
          :type="showOldPassword ? 'text' : 'password'"
          id="oldPassword"
          :icon="showOldPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
          :icon-clickable="!loading"
          @icon-click="showOldPassword = !showOldPassword"
          autocomplete="current-password"
          customRequired
          :customRequiredMessage="$t('managePassword.requiredMessage')"
          :disabled="loading"
        />
      </fieldset>
      <fieldset class="ba-mb-7">
        <vis-form-input
          v-model="form.newPassword"
          :label="$t('managePassword.newPasswdLabel')"
          :type="showNewPassword ? 'text' : 'password'"
          id="newPassword"
          :icon="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
          :icon-clickable="!loading"
          @icon-click="showNewPassword = !showNewPassword"
          autocomplete="new-password"
          customRequired
          :customRequiredMessage="$t('managePassword.requiredMessage')"
          :disabled="loading"
        />
        <vis-form-input
          v-model="form.repeatPassword"
          :label="$t('managePassword.repeatPasswdLabel')"
          :type="showRepeatPassword ? 'text' : 'password'"
          id="repeatPassword"
          :icon="showRepeatPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
          :icon-clickable="!loading"
          @icon-click="showRepeatPassword = !showRepeatPassword"
          autocomplete="new-password"
          customRequired
          :customRequiredMessage="$t('managePassword.requiredMessage')"
          :disabled="loading"
        />
      </fieldset>
      <vis-page-manage-controls
        v-if="!formSuccess"
        :submit-label="$t('button.changePassword')"
        :submitDisabled="!formIsValid || loading"
      />
      <vis-page-manage-back-button v-else @click="onReturn" />
    </form>
    <vis-logout-button
      v-if="forced"
      class="ba-justify-center ba-mt-10"
      :state="state"
      :token="token"
    />
  </div>
</template>

<script>
import VisPageManageHeader from "./vis-page-manage-header";
import VisPageManageControls from "./vis-page-manage-controls";
import VisPageManageBackButton from "./vis-page-manage-back-button";
import { manage2PasswordMixin } from "@ba/visary-account-common-vue";
import formMessagesMixin from "@/mixins/form-messages-mixin";

export default {
  name: "v-page-manage-password",
  components: {
    VisPageManageHeader,
    VisPageManageControls,
    VisPageManageBackButton
  },
  mixins: [manage2PasswordMixin, formMessagesMixin],
  data() {
    return {
      formSuccessMessage: this.$t("managePassword.formSuccessMessage"),
      formErrorMessage: this.$t("managePassword.formErrorMessage"),
      formDefaultMessage: this.$t("managePassword.formDefaultMessage")
    };
  },
  computed: {
    formMessages() {
      return {
        BadPassword: this.$t("formMessages.badPassword"),
        BadRequest: {
          newPassword: {
            MinLength: this.passwordMinLength,
            MinCapitalLetters: this.passwordMinCapitalLetters,
            MinCursiveLetters: this.passwordMinCursiveLetters,
            MinDigits: this.passwordMinDigits,
            MinSpecialCharacters: this.passwordMinSpecialCharacters,
            MaxLength: this.passwordMaxLength
          }
        }
      };
    }
  }
};
</script>
